import { driver, type Driver, type Popover, type DriveStep } from "driver.js";
import { libraryOpen, libraryTabSelected, soundBoard } from "../store";
import type { Action } from "svelte/action";
import { writable } from "svelte/store";
import {type TutorialStep, WELCOME, ASK_TO_OPEN_LIBRARY, EXPLAIN_LIBRARY, ASK_TO_CLICK_ON_SCENES_FILTER, ASK_TO_DRAG_SCENE_TO_SOUNDBOARD, EXPLAIN_SCENE_GLOBAL_CONTROLS, ASK_TO_OPEN_SCENE, EXPLAIN_AMBIENCE_LANE, EXPLAIN_MUSIC_LANE, EXPLAIN_SOUND_EFFECTS_LANE, SEARCH_LIBRARY_FOR_TUTORIAL_SCENE, NOW_LET_S_ADD_MUSIC, INTERSTITIAL, SEARCH_LIBRARY_FOR_A_TAG, ASK_TO_DRAG_MUSIC_TO_SCENE, THATS_IT, EXPLAIN_A_SCENE, FIDDLE_WITH_MUSIC, ASK_TO_CLICK_ON_MUSIC_FILTER, EXPLAIN_EPIC_SCENE_SOUND, STILL_HERE, EXPLAIN_AMBIENCE_LANE_LOOPING, EXPLAIN_AMBIENCE_ADVANCED} from "./TutorialSteps";


const steps: TutorialStep[] = [
    WELCOME,
    ASK_TO_OPEN_LIBRARY,
    EXPLAIN_LIBRARY,
    ASK_TO_CLICK_ON_SCENES_FILTER,
    SEARCH_LIBRARY_FOR_TUTORIAL_SCENE,
    ASK_TO_DRAG_SCENE_TO_SOUNDBOARD,
    EXPLAIN_A_SCENE,
    EXPLAIN_SCENE_GLOBAL_CONTROLS,
    EXPLAIN_EPIC_SCENE_SOUND,
    STILL_HERE,
    ASK_TO_OPEN_SCENE,
    EXPLAIN_AMBIENCE_LANE,
    EXPLAIN_AMBIENCE_LANE_LOOPING,
    EXPLAIN_AMBIENCE_ADVANCED,
    EXPLAIN_MUSIC_LANE,
    EXPLAIN_SOUND_EFFECTS_LANE,
    NOW_LET_S_ADD_MUSIC,
    INTERSTITIAL,
    ASK_TO_CLICK_ON_MUSIC_FILTER,
    SEARCH_LIBRARY_FOR_A_TAG,
    FIDDLE_WITH_MUSIC,
    ASK_TO_DRAG_MUSIC_TO_SCENE,
    THATS_IT,
]

export class Tutorial {
    driverObject: Driver;

    private highlightSoundboard() {
        this.driverObject.highlight({ element: "#soundboard-lanes" })
    }

    constructor() {
        this.driverObject = driver({
            popoverClass: 'tutorial-popover',
            showProgress: true,
            allowClose: false,
            nextBtnText: "->",
            prevBtnText: "<-",
            steps: steps.map((step) => step.driverStep)
        });
    }

    start() {
        this.driverObject.drive(0);
    }

    notifyNodeMount(mountedNode: HTMLElement) {
        if (!this.driverObject.isActive()) {
            return;
        }
        const activeIdx = this.driverObject.getActiveIndex();
        const activeTutorialStep = steps[activeIdx]
        if (activeTutorialStep.onComponentMounted) {
            activeTutorialStep.onComponentMounted(mountedNode, this.driverObject)
        }
    }
    notifyDetailsOpen(node: HTMLElement) {
        if (!this.driverObject.isActive()) {
            return;
        }
        const activeIdx = this.driverObject.getActiveIndex();
        const activeTutorialStep = steps[activeIdx]
        if (activeTutorialStep.onDetailsOpen) {
            activeTutorialStep.onDetailsOpen(node, this.driverObject)
        }

    }
    notifySearchChanged() {
        if (!this.driverObject.isActive()) {
            return;
        }
        const activeIdx = this.driverObject.getActiveIndex();
        const activeTutorialStep = steps[activeIdx]
        if (activeTutorialStep.onSearchChanged) {
            activeTutorialStep.onSearchChanged(this.driverObject)
        }
    }
}

function createTutorial() {
    const tut = new Tutorial()
    const { set, update, subscribe } = writable(tut)
    function notifyNodeMount(node: HTMLElement) {
        tut.notifyNodeMount(node)
    }
    function notifyDetailsOpen(node: HTMLElement) {
        tut.notifyDetailsOpen(node)
    }
    function notifySearchChanged() {
        tut.notifySearchChanged()
    }
    return {
        set,
        update,
        subscribe,
        notifyNodeMount,
        notifyDetailsOpen,
        notifySearchChanged,
    }
}
export const tutorial = createTutorial();

export const notifyWhenMounted: Action = (node) => {
    tutorial.notifyNodeMount(node)
    return {}
}
export const notifyWhenOpen: Action = (node) => {
    tutorial.notifyDetailsOpen(node)
    return {}
}
